import {
  SkeletonLoader
} from "oolib";
import React, { useMemo } from "react";
import { ListingModuleAnnotationExplorer } from "../../../../../../../../components/analysisModules/AnnotationExplorer/comps/ListingModuleAnnotationExplorer";
import { useGetAnnotationExplorerData } from "../../../../../../../../components/analysisModules/AnnotationExplorer/useGetAnnotationExplorerData";
import { getAnnoExplorerConfigsForThisTenant } from "../../../../../../../../components/analysisModules/AnnotationExplorer/utils/getAnnoExplorerConfigsForThisTenant";
import FilterModule from "../../../../../../../../components/discovery/FilterModule";
import { parseSpecialConfigSyntax } from "@okf/ootils";
import { FilterPlusBodyShellForCollectionPages } from "./FilterPlusBodyShellForCollectionPages";
import { useElemInView } from "@/utils/customHooks/useElemInView";
import { useGetAnnotationsLazy } from "@/utils/react-query-hooks/getData";

export const AnnoExplorerRendererInCollectionPage = ({
  content,
  tabsPanelHeight,
  actionBarHeight,
  presetActiveFilters: _presetActiveFilters //passed via config.props (from the tpl)
}) => {
  const annoExplorerConfigs = getAnnoExplorerConfigsForThisTenant();

  const presetActiveFilters = useMemo(() => {
    const defaultPresetFilters = [
      {
        target: {
          filterType: "tagType",
          tagType: content.meta.kp_content_type,
        },
        source: {
          scope: "tags",
        },
        values: [{ value: "$valuePath(_id)" }],
      },
      // for a rollup situation it would look something like this.
      // {
      //   filterId: "tags_participantRegistrationTemplates_regionsNigeria",
      //   source: {
      //     scope: "tags"
      //   },
      //   target: {
      //     filterType: "nestedRollupTagType",
      //     rollupPath: ["participantsRegistrationTemplates", content.meta.kp_content_type] // from bottom to top of hierarchy
      //   },
      //   values: [{ value: "$valuePath(_id)" }],
      // }
    ];

    return parseSpecialConfigSyntax({
      config: _presetActiveFilters || defaultPresetFilters,
      content,
    });
  }, [content]);

  // Use the new hook with tenant-specific configuration
  const {
    tplOptions,
    tplOptionsDropdownData,
    totalData,
    totalCount,
    selectedTpls,
    setSelectedTpls,
    activeFilters,
    setActiveFilters,
    filterConfigs,
    sortOptions,
    activeSort,
    setActiveSort,
    keyword,
    setKeyword,
    
    // observerRef,
    // dataFetchStatus,
    // data,
    // error,
  } = useGetAnnotationExplorerData({
    presetActiveFilters,
    // Use whitelist from annoExplorerConfigs
    contentTypesWhitelist: annoExplorerConfigs?.contentTypes?.whitelist,
    initialCardsLimit: 20,
  });
  
  
   const { 
      data, 
      fetchNextPage, 
      hasNextPage, 
      status: dataFetchStatus,
      error,
      isFetchingNextPage,
      colorBreakdownStats,
    } = useGetAnnotationsLazy({
      activeFilters: [
        ...presetActiveFilters,
        ...activeFilters, 
      ],
      dataSource: "annotations",
      // searchConfig: {
      //   type: "keyword",
      //   fields: ["annotations.fragment.allText", "contentEnhancedText"],
      // },
      translationConfig: {
        customBlocks: [
          { comp: "TitleInput", props: {}, valuePath: "main.title" },
          {
            comp: "LexicalTextEditor",
            props: {},
            valuePath: "annotations.fragment",
          },
        ],
      },
      activeSort,
      searchTerm: keyword,
      // findQuery,
      limit: 20,
      // queryId: `document-${documentId}`
  });

  const { observerRef } = useElemInView({
    callback: fetchNextPage,
    enabled: !!hasNextPage && !isFetchingNextPage,
  });

  const sidebarWidth = 300;

  const filterStickyTop = (actionBarHeight || 0) + (tabsPanelHeight || 0);

  return (
    <FilterPlusBodyShellForCollectionPages
      filterStickyTop={filterStickyTop}
      leftComp={
        filterConfigs && (
          <FilterModule
            usesAnnoFilters={true}
            filterConfig={filterConfigs}
            activeFilters={activeFilters}
            setActiveFilters={setActiveFilters}
            presetActiveFilters={presetActiveFilters}
            orientation="sidebar"
            expandedWidth={sidebarWidth}
            usedIn={"annoExplorerRendererInCollectionPagw"}
          />
        )
      }
    >
      {dataFetchStatus === "loading" ? (
        [1, 2, 3].map((d) => <SkeletonLoader style={{ height: "300px" }} />)
      ) : (
        <ListingModuleAnnotationExplorer
          data={data?.pages?.flatMap(page => page.data)}
          totalCount={data?.pages[0]?.count}
          dataFetchStatus={dataFetchStatus}
          dataFetchError={error}
          observerRef={observerRef}
        />
      )}
    </FilterPlusBodyShellForCollectionPages>
  );
};
